<template>
  <div>
    <IAISelect.Wrapper
      v-model="selectedSort"
      class="min-w-[8rem] md:min-w-[12rem]"
      :selected-option-label="selectedOption?.label"
    >
      <IAISelect.Item
        v-for="option in sortOptions"
        :key="option.value"
        :option="{ key: option.value, label: option.label }"
        :is-selected="selectedSort === option.value"
      />
    </IAISelect.Wrapper>
  </div>
</template>

<script setup lang="ts">
import { IAISelect } from "@/core-ui-vue";
import { useProfileShopFilters } from "@/features/profile-shop/composables/useProfileShopFilters";
import { computed } from "vue";
import type { FilterOption } from "@/features/profile-shop/services/api";

const filters = useProfileShopFilters();

const { filtersList, activeFilters, toggleFilter } = filters;

const sortOptions = computed(() => filtersList.sort);

const selectedSort = computed({
  get: () => activeFilters.value.sort,
  set: (value: string) => {
    toggleFilter("sort", value, "filter_panel");
  },
});

const selectedOption = computed(() =>
  sortOptions.value.find((option: FilterOption) => option.value === selectedSort.value)
);
</script>
